class isue_eventtype extends Tango.Component {
	widgetDidMount() {
		var t = this;	

		document.querySelectorAll("input[name*='onoff']").forEach(function (el) {
			el.onchange = function (e) {
				var tr = e.target.closest('tr');
				var linked_id = tr.querySelector('select').value;
				document.querySelectorAll('option:checked[value="' + linked_id + '"]').forEach(function (opt) {
					var chk = opt.closest('tr').querySelector("input[name*='onoff']");
					ajaxUtils.state.ctrl[chk.id].setValue(e.target.checked);
					chk.closest('td').style.backgroundColor = chk.getAttribute("data-val").toLowerCase() == chk.checked.toString() ? null : "lightGreen";
				});
				e.target.closest('td').style.backgroundColor = e.target.getAttribute("data-val").toLowerCase() == e.target.checked.toString() ? null : "lightGreen";
				t.highlightApply();
			};
		});
		
		document.querySelectorAll("input[name*='sendtoeir']").forEach(function (el) {
			el.onchange = function (e) {
				var tr = e.target.closest('tr');
				var linked_id = tr.querySelector('select').value;
				document.querySelectorAll('option:checked[value="' + linked_id + '"]').forEach(function (opt) {
					var chk = opt.closest('tr').querySelector("input[name*='sendtoeir']");
					ajaxUtils.state.ctrl[chk.id].setValue(e.target.checked);
					chk.closest('td').style.backgroundColor = chk.getAttribute("data-val").toLowerCase() == chk.checked.toString() ? null : "lightGreen";
				});
				e.target.closest('td').style.backgroundColor = e.target.getAttribute("data-val").toLowerCase() == e.target.checked.toString() ? null : "lightGreen";
				t.highlightApply();
			};
		});

		document.querySelectorAll("input[name*='unreliabledata']").forEach(function (el) {
			el.onchange = function (e) {
				var tr = e.target.closest('tr');
				var linked_id = tr.querySelector('select').value;
				// document.querySelectorAll('option:checked[value="' + linked_id + '"]').forEach(function (opt) {
				// 	var chk = opt.closest('tr').querySelector("input[name*='unreliabledata']");
				// 	ajaxUtils.state.ctrl[chk.id].setValue(e.target.checked);
				// 	chk.closest('td').style.backgroundColor = chk.getAttribute("data-val").toLowerCase() == chk.checked.toString() ? null : "lightGreen";
				// });
				e.target.closest('td').style.backgroundColor = e.target.getAttribute("data-val").toLowerCase() == e.target.checked.toString() ? null : "lightGreen";
				t.highlightApply();
			};
		});
        
		document.querySelectorAll("select[name*='let']").forEach(function (el) {
			el.onchange = function (e) {
				var tr = e.target.closest('tr');
				var linked_id = e.target.value;
				var ischeckedSendToEir = tr.querySelector("input[name*='sendtoeir']").checked;
				var ischeckedIsCritical = tr.querySelector("input[name*='onoff']").checked;
				var ischeckedIsUnreliableData = tr.querySelector("input[name*='unreliabledata']").checked;
				document.querySelectorAll('option:checked[value="' + linked_id + '"]').forEach(function (opt) {
					var chkSendToEir = opt.closest('tr').querySelector("input[name*='sendtoeir']");
					ajaxUtils.state.ctrl[chkSendToEir.id].setValue(ischeckedSendToEir);
					chkSendToEir.closest('td').style.backgroundColor = chkSendToEir.getAttribute("data-val").toLowerCase() == chkSendToEir.checked.toString() ? null : "lightGreen";

					var chkIsCritical = opt.closest('tr').querySelector("input[name*='onoff']");
					ajaxUtils.state.ctrl[chkIsCritical.id].setValue(ischeckedIsCritical);
					chkIsCritical.closest('td').style.backgroundColor = chkIsCritical.getAttribute("data-val").toLowerCase() == chkIsCritical.checked.toString() ? null : "lightGreen";

					var chkIsUnreliableData = opt.closest('tr').querySelector("input[name*='unreliabledata']");
					ajaxUtils.state.ctrl[chkIsUnreliableData.id].setValue(ischeckedIsUnreliableData);
					chkIsUnreliableData.closest('td').style.backgroundColor = chkIsUnreliableData.getAttribute("data-val").toLowerCase() == chkIsUnreliableData.checked.toString() ? null : "lightGreen";
				});
				e.target.closest('td').style.backgroundColor = e.target.getAttribute("data-val") == e.target.value ? null : "lightGreen";
				t.highlightApply();		
			};
		});		
		t.highlightApply();
	}

	highlightApply() {
		var changed = false;
		document.querySelectorAll("input[name*='sendtoeir'], input[name*='onoff'], input[name*='unreliabledata']").forEach(function (el) {
			if (el.getAttribute("data-val").toLowerCase() != el.checked.toString())
				changed = true;
		});
		document.querySelectorAll("select[name*='let']").forEach(function (el) {
			if (el.getAttribute("data-val") != el.value)
				changed = true;
		});
		document.getElementById('isue_eventtype_list_apply').style.backgroundColor = changed ? "lightGreen" : "#dddddd";
		document.getElementById('isue_eventtype_list_apply').style.pointerEvents = changed ? null : "none";
		document.getElementById('isue_eventtype_list_apply').style.cursor = changed ? null : "default";
	}
};

Tango.registerComponent(isue_eventtype, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	listview: listview,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));